import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";
import type { ApiResponse } from "../types/api";

export interface Skill {
  name: string;
  name_ar?: string;
  status?: boolean;
}

export type SkillUpdateBody = Partial<Skill>;

interface SkillsListResponse {
  data: Array<Skill & { _id: string; createdAt?: string }>;
}

export const skillsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSkills: builder.query<
      ApiResponse<SkillsListResponse>,
      void
    >({
      query: () => ({
        url: `${END_POINTS.skills}`,
        method: "GET",
      }),
    }),
    getSkillById: builder.query<
      ApiResponse<Skill & { _id: string }>,
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.skills}/${id}`,
        method: "GET",
      }),
    }),
    createSkill: builder.mutation<ApiResponse<Skill & { _id: string }>, { data: Skill }>({
      query: (body) => ({
        url: END_POINTS.skills,
        method: "POST",
        body: body?.data,
      }),
    }),
    updateSkill: builder.mutation<
      ApiResponse<Skill & { _id: string }>,
      { id: string; body: SkillUpdateBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.skills}/${id}`,
        method: "PUT",
        body: body,
      }),
    }),
    deleteSkill: builder.query<
      ApiResponse<{ _id: string }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.skills}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllSkillsQuery,
  useLazyGetSkillByIdQuery,
  useCreateSkillMutation,
  useUpdateSkillMutation,
  useLazyDeleteSkillQuery,
} = skillsApi;
